import * as R from 'ramda';
import { compareAsc } from 'date-fns/fp';

const pageLimit = 20;

/**
 * checkIsSearching :: String -> Boolean
 */
export const checkIsSearching = (term = '') => !!term && term.length > 1;

/**
 * sortContacts :: [Contact] -> [Contact]
 */
export const sortContactsByLastRequestDate = R.sortWith([
  (a, b) => compareAsc(a.lastRequestDate, b.lastRequestDate),
]);

/**
 * sortAndSliceContacts :: [Contact] -> [Contact]
 */
export const sortAndSliceContacts = (contacts, page) =>
  R.compose(
    R.slice(0, pageLimit * R.max(1, page)),
    sortContactsByLastRequestDate,
  )(contacts);

/**
 * deleteFalseElements :: [Array | Object] -> [Array | Object]
 */
export const deleteFalseElements = item => R.filter(n => !!n, item);



// WEBPACK FOOTER //
// ./src/utils/contacts.js